<script setup lang="ts">
import type { HTMLAttributes } from 'vue';
import { reactiveOmit } from '@vueuse/core';
import { Separator, type SeparatorProps } from 'reka-ui';
import { cn } from '@/lib/utils';

const props = withDefaults(defineProps<SeparatorProps & { class?: HTMLAttributes['class'] }>(), {
  orientation: 'horizontal',
  decorative: true,
});

const delegatedProps = reactiveOmit(props, 'class');
</script>

<template>
  <Separator
    v-bind="delegatedProps"
    :class="
      cn(
        'tw-shrink-0 tw-bg-neutral-200 dark:tw-bg-neutral-800',
        props.orientation === 'horizontal' ? 'tw-h-px tw-w-full' : 'tw-w-px tw-h-full',
        props.class
      )
    "
  />
</template>
